import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from 'vue';
import { useStore } from 'vuex';
export default {
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const toggleClick = () => {
      store.commit('app/triggerSidebarOpened');
    };
    const icon = computed(() => store.getters.sidebarOpened ? 'hamburger-opened' : 'hamburger-closed');
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", {
        class: "hamburger-container",
        onClick: toggleClick
      }, [_createVNode(_component_svg_icon, {
        id: "guide-hamburger",
        class: "hamburger",
        icon: icon.value
      }, null, 8, ["icon"])]);
    };
  }
};